import { render, staticRenderFns } from "./ReplaceTextModal.vue?vue&type=template&id=6c0b22fb"
import script from "./ReplaceTextModal.vue?vue&type=script&lang=js"
export * from "./ReplaceTextModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c0b22fb')) {
      api.createRecord('6c0b22fb', component.options)
    } else {
      api.reload('6c0b22fb', component.options)
    }
    module.hot.accept("./ReplaceTextModal.vue?vue&type=template&id=6c0b22fb", function () {
      api.rerender('6c0b22fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/modals/ReplaceTextModal.vue"
export default component.exports